/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Finnish
export default {
  'extension.charts.aggregateData': 'Koosta tiedot',
  'extension.charts.aggregateDataDescription':
    'Yhdistä arvot yhdeksi tietopisteeksi, kun useammalla rivillä on sama arvo.',
  'extension.charts.category': 'Kategoria',
  'extension.charts.customizeTab': 'Mukauta',
  'extension.charts.dataMissing.details': 'Emme löydä tämän kaavion lähdetaulukkoa sivulta.',
  'extension.charts.dataMissing.title': 'Ei tietoja näytettäväksi',
  'extension.charts.dataTab': 'Tiedot',
  'extension.charts.defaultColumnName': 'Sarake {0}',
  'extension.charts.defaultTitle': 'Nimeämätön kaavio',
  'extension.charts.defaultYLabel': 'Nimeämätön akseli',
  'extension.charts.extensionTitle': 'Kaavio',
  'extension.charts.height': 'Piirtoalueen korkeus',
  'extension.charts.height.large': 'Korkeampi',
  'extension.charts.height.medium': 'Oletus',
  'extension.charts.height.small': 'Matalampi',
  'extension.charts.horizontal.orientation.label': 'Vaakasuora',
  'extension.charts.insert.tooltip': 'Lisää kaavio',
  'extension.charts.legend': 'Selite',
  'extension.charts.legend.auto': 'Automaattinen',
  'extension.charts.legend.bottom': 'Alapuoli',
  'extension.charts.legend.left': 'Vasen',
  'extension.charts.legend.position': 'Selitteen sijainti',
  'extension.charts.legend.right': 'Oikea',
  'extension.charts.legend.show': 'Näytä selite',
  'extension.charts.legend.top': 'Yläpuoli',
  'extension.charts.options.label': 'Kaavion valinnat',
  'extension.charts.options.tooltip': 'Muuta kaavion valintoja',
  'extension.charts.orientation.label': 'Suunta',
  'extension.charts.seriesNames': 'Tietosarjat',
  'extension.charts.showPoints': 'Näytä tietopisteet',
  'extension.charts.smoothLines': 'Sulavat viivat',
  'extension.charts.style': 'Tyyli',
  'extension.charts.title': 'Otsikko',
  'extension.charts.type.bar': 'Palkki',
  'extension.charts.type.fieldDescription': 'Kaaviotyyppi',
  'extension.charts.type.line': 'Viiva',
  'extension.charts.type.pie': 'Piirakka',
  'extension.charts.userTitle': 'Otsikko',
  'extension.charts.vertical.orientation.label': 'Pystysuuntainen',
  'extension.charts.xAxis': 'X-akseli',
  'extension.charts.xLabel': 'X-akselin leima',
  'extension.charts.yLabel': 'Y-akselin nimiö',
};
